import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';
import Chip from '@material-ui/core/Chip';
import { Form, TextArea } from 'semantic-ui-react'
import Add from '@material-ui/icons/Add';
import Avatar from '@material-ui/core/Avatar';

class Title extends React.Component {

  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'xs',
    maxWidth1: 'md',
    template: []
  }

  getTemplate() {
    let context = this;
    context.setState({ load: true, message: 'Getting Templates!!!' });
    $.ajax({
      type: 'POST',
      url: Server() + 'sms/gettemplate.php',
      success: function(data)
      {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          context.setState({ template: data, open: true })
        } catch (e) {
          alert('Try Again!!!');
        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }


  submit() {
    let context = this;
    let template = this.state.template;
    context.setState({ load: true, message: 'Adding Templates!!!' });
    $.ajax({
      type: 'POST',
      data: { 'template': context.state.addTemplate },
      url: Server() + 'sms/addtemplates.php',
      success: function(data)
      {
        context.setState({ load: false });
        if (data == 1) {
          template.push({ template: context.state.addTemplate })
          context.setState({ openAddTemplate: false, template: template, addTemplate: '' })
        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  onChange = (type) => event => {
    this.setState({ [type]: event.target.value })
  }

  seletedTemplate(template) {
    this.props.template(template);
    this.setState({ open: false })
  }

  render() {
    let i = 1;
    return (
      <div>
        <u id='pointer' onClick={this.getTemplate.bind(this)}>View Template</u>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Templates</DialogTitle>
          <DialogContent>
            <Chip label={'ADD TEMPLATE'} onClick={ () => { this.setState({ openAddTemplate: true }) }} id='pointer' avatar={<Avatar><Add /></Avatar>} color='primary' /><br/><br/>
            <table id='table' width='100%'>
              <tr>
                <th id='th' style={{width: '5%'}}><center>Sino</center></th>
                <th id='th'><center>Template</center></th>
              </tr>
              { this.state.template.map((c) => {
                  return (
                    <tr id='tbody'>
                      <td><center>{i++}</center></td>
                      <td onClick={this.seletedTemplate.bind(this, c.template)}>{c.template}</td>
                    </tr>
                  )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary">Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.openAddTemplate} onClose={ () => { this.setState({ openAddTemplate: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Add Templates</DialogTitle>
          <DialogContent>
            <Form>
              <TextArea rows={2} onChange={this.onChange('addTemplate')}
              value={this.state.addTemplate} fluid placeholder='Template' />
            </Form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit.bind(this)} color="primary">Add</Button>
            <Button onClick={ () => { this.setState({ openAddTemplate: false }) }} color="primary">Close</Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

export default Title;
